import { render } from "./BacklogItem.vue?vue&type=template&id=94470d06&scoped=true"
import script from "./BacklogItem.vue?vue&type=script&lang=js"
export * from "./BacklogItem.vue?vue&type=script&lang=js"

import "./BacklogItem.vue?vue&type=style&index=0&id=94470d06&scoped=true&lang=css"

import exportComponent from "/github/workspace/src/mealplanner-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94470d06"]])

export default __exports__